// traducciones-es.ts
export const TRANSLATIONS_ES = {
    camera: {
      label:'Subir Imagen',
      takePhoto: 'Tomar Foto',
      gallery: 'Galería',
      // Otros textos que quieras traducir
    }
  };
  